export default "__VITE_ASSET__$U65vQ6D__"